import { createRouter, createWebHashHistory } from "vue-router";
import Index from "../views/Index/index.vue";

const routes = [
  {
    path: "/",
    name: "index",
    component: Index,
  },
  // 青秀区人民法院公众号——诉前调解
  {
    path: "/qingxiu-search",
    name: "qingxiuSearch",
    component: () => import("../views/QingxiuSearch/index.vue"),
  },
  {
    path: "/qingxiu-detail",
    name: "qingxiuDetail",
    component: () => import("../views/QingxiuDetail/index.vue"),
  },
  // 防城港市港口区法院公众号
  {
    path: "/gangkou-search",
    name: "gangkouSearch",
    component: () => import("../views/GangkouSearch/index.vue"),
  },
  {
    path: "/gangkou-detail",
    name: "gangkouDetail",
    component: () => import("../views/GangkouDetail/index.vue"),
  },
  // 良庆区法院公众号
  {
    path: "/liangqing-search",
    name: "liangqingSearch",
    component: () => import("../views/LiangqingSearch/index.vue"),
  },
  {
    path: "/liangqing-detail",
    name: "liangqingDetail",
    component: () => import("../views/LiangqingDetail/index.vue"),
  },
  //回款上传凭证(H5、公众号 通用)
  {
    path: "/uploadFile",
    name: "UploadFile",
    component: () => import("../views/UploadFile/index.vue"),
  },
  {
    path: "/NotFound",
    name: "NotFound",
    component: () => import("../views/NotFound/index.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
// createWebHashHistory
router.beforeEach((to, from, next) => {
  console.log("process", process.env);
  if (!to.query.clientId) {
    var useragent = navigator.userAgent;
    if (useragent.match(/MicroMessenger/i) != "MicroMessenger") {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=88";
    }
  }
  // 当前路由没有匹配项
  if (to.matched.length === 0) {
    next("/NotFound"); // 跳转到404页面
  } else {
    next();
  }
  return true;
});
export default router;
